import { Link, Typography } from "@mui/material";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { getTitlePrefix } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/configuratorTreeTitlePrefix.ts";
import {
	PropertyModelNodeIssues,
	PropertyModelNodePath,
	propertyModelNodePathKey,
} from "src/components/views/erp/configurator/configuratorForm/propertyModel/propertyModelInputTree.ts";

export interface PropertyModelIssuesViewProps {
	groups: PropertyModelNodeIssues[];
	/** Opens the configuration at [path] in the form. */
	selectNode: (path: PropertyModelNodePath) => void;
}

/** The issues of a property-model tree by configuration, in tree order, each configuration opening from its title. */
export function PropertyModelIssuesView({ groups, selectNode }: PropertyModelIssuesViewProps) {
	return (
		<VerticalBox sx={{ padding: 2, gap: 2 }}>
			{groups.map(({ node, label, issues }) => (
				<VerticalBox key={propertyModelNodePathKey(node.path)} sx={{ paddingLeft: node.path.length * 2 }}>
					<Link
						component={"button"}
						variant={"body1"}
						underline={"hover"}
						sx={{ alignSelf: "flex-start", fontWeight: "bold", textAlign: "left" }}
						onClick={() => selectNode(node.path)}
					>
						{`${getTitlePrefix(node.path.length)} ${label}`}
					</Link>
					<VerticalBox component={"ul"} sx={{ margin: 0, paddingLeft: 3 }}>
						{issues.map((issue, index) => (
							<Typography key={index} component={"li"}>
								{issue.message}
							</Typography>
						))}
					</VerticalBox>
				</VerticalBox>
			))}
		</VerticalBox>
	);
}
